import React, { useState, useEffect } from 'react';
import MainContent from '../components/MainContent/MainContent';
import { API_ENDPOINTS } from '../config/apiConfig';

// Define the product type
interface Product {
  id: number;
  name: string;
  logoUrl: string;
  description: string[];
  minPrice: {
    amount: number;
    unit: string;
  };
  duration: string;
  options?: {
    label: string;
    price: {
      amount: number;
      unit: string;
    };
  }[];
}

const PrestationsPage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.PRODUCTS);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const productsData = await response.json();
        setProducts(productsData);
      } catch (err) {
        setError('Failed to fetch products');
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <div>Loading products...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <MainContent products={products} />
    </>
  );
};

export default PrestationsPage;